import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {DataFormatService} from "../../../services/data-format.service";
import {FormControl} from "@angular/forms";
import {update_review_findings, update_env_findings, update_construction_details} from "./graphql/alterConstruction";
import {Apollo} from "apollo-angular";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

export interface constructionTable {
  field: string;
  value: string;
  type: string;
}

@Component({
    selector: 'deal-construction',
    templateUrl: './construction.component.html',
    styleUrls: ['./construction.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConstructionComponent implements OnInit{
  @Input() construction: any;
  @Input() permissions: any;
  @Input() projectid: string;

  dataColumns: string[] = ['field', 'value'];
  dataSource: MatTableDataSource<constructionTable>;

  reviewFindings: string = '';
  reviewEditMode: boolean = false;
  review: FormControl;
  reviewChanged: boolean = false;

  envReview: string = '';
  envEditMode: boolean = false;
  env: FormControl;
  envChanged: boolean = false;

  isEditMode: boolean = false;

  lossValue: number = 0;
  newLossValue: number = 0;

  conditionsPureBool: boolean | null = null;
  conditions: boolean | string = 'n/a';
  newConditions: boolean | string = 'n/a';

  constructor(private dataFormat: DataFormatService,
              private apollo: Apollo,
              private _snackBar: MatSnackBar) {}


  ngOnInit() {
    if(this.construction){
      this.conditionsPureBool = this.construction.recognized_enviromental_conditions;
      if(this.construction.recognized_enviromental_conditions !== null){
        this.conditions = this.construction.recognized_enviromental_conditions;
        this.newConditions = this.construction.recognized_enviromental_conditions;
      }
      this.lossValue = Number(this.construction.probable_max_loss);
      this.newLossValue = Number(this.construction.probable_max_loss);

      this.reviewFindings = this.construction.construction_review_findings;
      this.review = new FormControl(this.construction.construction_review_findings);

      this.envReview = this.construction.environment_review_findings;
      this.env = new FormControl(this.construction.environment_review_findings);
    } else {
      this.reviewFindings = '';
      this.review = new FormControl('');

      this.envReview = '';
      this.env = new FormControl('');
    }
    this.formatTableData();
  }

  formatTableData(){
    let constructionTable: Array<constructionTable>;

    constructionTable = [
      {field: 'Probable Maximum Loss', type: 'number', value: this.lossValue.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        })},
      {field: 'Any Environmental Conditions identified in Phase I?', type: 'bool dropdown', value: this.dataFormat.yesNoFormat(this.conditionsPureBool)}
    ];

    this.dataSource = new MatTableDataSource(constructionTable);
  }

  toggleReviewEditMode(){
    if(this.reviewEditMode && this.reviewChanged){
      let mutate = {};
      if(this.construction){
        mutate = {
          id: this.construction.id,
          project_id: this.projectid,
          construction_review_findings: this.review.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          construction_review_findings: this.review.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_review_findings,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.construction = data.updateReviewFindings;
            this.reviewFindings = this.construction.construction_review_findings;
            this.review.setValue(this.reviewFindings);
            this.reviewChanged = false;
            this.openSnackBar('Construction Review Findings has been updated successfully.');
          }
        );
    }
    this.reviewEditMode = !this.reviewEditMode;
  }

  toggleEnvEditMode(){
    if(this.envEditMode && this.envChanged){
      let mutate = {};
      if(this.construction){
        mutate = {
          id: this.construction.id,
          project_id: this.projectid,
          environment_review_findings: this.env.value
        }
      } else {
        mutate = {
          project_id: this.projectid,
          environment_review_findings: this.env.value
        }
      }
      this.apollo
        .mutate({
          mutation: update_env_findings,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.construction = data.updateEnvFindings;
            this.envReview= this.construction.environment_review_findings;
            this.env.setValue(this.envReview);
            this.envChanged = false;
            this.openSnackBar('Environment Review Findings has been updated successfully.');
          }
        );
    }
    this.envEditMode = !this.envEditMode;
  }

  toggleEditMode(){
    if(this.isEditMode && (this.lossValue !== this.newLossValue || this.conditions !== this.newConditions)){
      let conditionsbool: boolean | null;
      if(this.newConditions === 'n/a'){
        conditionsbool = null;
      } else{
        conditionsbool = Boolean(this.newConditions);
      }

      let mutate = {};
      if(this.construction){
        mutate = {
          id: this.construction.id,
          project_id: this.projectid,
          probable_max_loss: Number(this.newLossValue),
          recognized_enviromental_conditions: conditionsbool
        }
      } else {
        mutate = {
          project_id: this.projectid,
          probable_max_loss: Number(this.newLossValue),
          recognized_enviromental_conditions: conditionsbool
        }
      }
      this.apollo
        .mutate({
          mutation: update_construction_details,
          variables: mutate,
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            let newdata: any = data.updateConstructionDetails;

            this.lossValue = Number(newdata.probable_max_loss);
            this.newLossValue = Number(newdata.probable_max_loss);

            this.conditionsPureBool = newdata.recognized_enviromental_conditions;

            if(this.conditionsPureBool !== null){
              this.conditions = newdata.recognized_enviromental_conditions;
              this.newConditions = newdata.recognized_enviromental_conditions;
            } else {
              this.conditions = 'n/a';
              this.newConditions = 'n/a';
            }

            this.formatTableData();
            this.openSnackBar('Construction Details has been updated successfully.');
          }
        );
    }
    this.isEditMode = !this.isEditMode;
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }
}
